import React from "react";
import { IconId, Text, Option, Tooltip } from "src/components";
import { theme } from "src/config";
import { ItemType, LoadingStatus } from "src/types";
import styled from "styled-components";
import { MenuEntry } from "./menuEntry";


export interface Section {
  entries:    Entry[],
  title:      string,
  content?:    string,
  hidden?:    boolean,
  highlight?: boolean,
}
export interface Entry {
  itemType?:     ItemType,
  disabled?:     boolean,
  hidden?:       boolean,
  iconId?:       IconId,
  iconColor?:    string,
  isLoading?:    LoadingStatus,
  options?:      Option[], // used for select types "items", "user", "users"
  showLoadMore?: boolean,
  content?:      string,
  tooltip?:      string,
  title:         string,
  type:          "checkbox" | "action" | "date" | "items" | "user" | "users" | "time" | "select" | "number" | "progressSlider",
  value?:        any,
  step?:         number
  placeholder?:  string,
  validRange?:   {start?: any, end?: any},
  onChange?(value: any): void,
  onAdd?   (value: any): void,
  onRemove?(value: any): void,
  onClick? ():          void,
  onLoad?  ():          void,
  onOpenSelect?(open: boolean): void,
}
export interface MenuBarProps {
  sections: Section[],
  tooltip?: string,
}

export const MenuBar = (props: MenuBarProps): JSX.Element => {
  const { sections } = props;
  return (
    <Container>
      <div>
      {sections.map(s => !s.hidden && (
        <SectionContainer key={s.title+'container'} highlight={s.highlight}>
          <Text capitalized weight={"bold"} size="default">{s.title}</Text>
          {s.entries.map(e => (
            !e.hidden && <Tooltip key={e.title+'tool'} placement="top" content={ e.disabled && e.tooltip}><MenuEntry {...e} key={e.title+'menu'} /></Tooltip>
          ))}
          <Text size="xsmall" color="grayDefault">{s.content}</Text>
        </SectionContainer>
      ))}
      </div>
    </Container>
  );
}

const Container = styled.div`
  padding-left:   1rem;
  border-left:    1px solid ${theme.color.secondaryBorder};
  height:         100%;
  display:        flex;
  gap:            0.5rem;
  flex-direction: column;
  justify-content: space-between;
`;


const SectionContainer = styled.div<{highlight: boolean}>`
  margin-top:       0.2rem;
  padding:          0.4rem;
  border-radius:    0.4rem;
  background-color: ${props => props.highlight ? theme.color.activeItem : undefined};
  border: ${props => props.highlight ? `1px solid ${theme.color.primaryA1}` : undefined};
  > p {
    margin-bottom: 0.7rem;
  }
`;